<template>
  <v-col cols="12">
    <v-alert
      v-if="error"
      :class="uiComponentProperties.rounded ? 'rounded-b-pill rounded-t-pill' : ''"
      :text="uiComponentProperties.text"
      :value="true"
      class="text-left"
      type="error"
    >
      {{ error }}
    </v-alert>

    <v-alert
      v-if="sent && (!error || error.length < 1)"
      :class="uiComponentProperties.rounded ? 'rounded-b-pill rounded-t-pill' : ''"
      :text="uiComponentProperties.text"
      :value="true"
      class="text-left"
      type="success"
    >
      {{ $t('login.password_reset_email_sent') }}
    </v-alert>

    <v-text-field
      v-model="username"
      :color="uiComponentProperties.inputColor"
      :disabled="sent"
      :label="$t('login.username')"
      :outlined="uiComponentProperties.outlined"
      :rounded="uiComponentProperties.rounded && uiComponentProperties.outlined"
      autofocus
      class="mb-8"
      hide-details
      v-on:keyup.enter="submit"
    />

    <v-text-field
      v-if="sent"
      v-model="code"
      :color="uiComponentProperties.inputColor"
      :label="$t('login.code')"
      :outlined="uiComponentProperties.outlined"
      :rounded="uiComponentProperties.rounded && uiComponentProperties.outlined"
      class="mb-8"
      hide-details
    />

    <v-text-field
      v-if="sent"
      v-model="password"
      :append-icon="showPassword ? 'mdi mdi-eye' : 'mdi mdi-eye-off'"
      :color="uiComponentProperties.inputColor"
      :label="$t('login.new_password')"
      :outlined="uiComponentProperties.outlined"
      :rounded="uiComponentProperties.rounded && uiComponentProperties.outlined"
      :type="showPassword ? 'text' : 'password'"
      class="mb-8"
      hide-details
      v-on:keyup.enter="verify"
      @click:append="showPassword = !showPassword"
    />

    <div class="text-center">
      <template v-if="sent">
        <v-btn
          :class="uiComponentProperties.buttonClass"
          :color="uiComponentProperties.buttonColor"
          :disabled="!username"
          :loading="loading"
          :rounded="uiComponentProperties.rounded"
          block
          class="font-weight-bold"
          large
          @click="verify"
        >
          {{ $t('login.change_password') }}
        </v-btn>
        <v-btn
          :color="uiComponentProperties.buttonColor"
          :disabled="loading"
          :rounded="uiComponentProperties.rounded"
          :small="$vuetify.breakpoint.xsOnly"
          block
          class="mt-3 font-weight-regular"
          text
          @click="submit"
        >
          {{ $t('login.resend_code') }}
        </v-btn>
      </template>
      <template v-else>
        <v-btn
          :class="uiComponentProperties.buttonClass"
          :color="uiComponentProperties.buttonColor"
          :disabled="!username"
          :loading="loading"
          :rounded="uiComponentProperties.rounded"
          block
          class="font-weight-bold"
          large
          @click="submit"
        >
          {{ $t('login.send_code') }}
        </v-btn>
      </template>
      <v-btn
        :color="uiComponentProperties.buttonColor"
        :disabled="loading"
        :rounded="uiComponentProperties.rounded"
        :small="$vuetify.breakpoint.xsOnly"
        block
        class="mt-3 font-weight-regular"
        text
        @click="signIn"
      >
        <v-icon left>mdi mdi-arrow-left</v-icon>
        {{ $t('login.back_to_sign_in') }}
      </v-btn>
    </div>
  </v-col>
</template>

<script>
import {AmplifyEventBus} from 'aws-amplify-vue';
import * as AmplifyUI from '@aws-amplify/ui';

export default {
  name: 'ForgotPassword',
  props: ['forgotPasswordConfig', 'uiComponentProperties'],
  data() {
    return {
      loading: false,
      username: '',
      code: '',
      password: '',
      error: '',
      sent: false,
      showPassword: false,
      logger: {},
      amplifyUI: AmplifyUI,
    };
  },
  computed: {
    options() {
      const defaults = {
        header: this.$Amplify.I18n.get('Reset your password'),
      };
      return Object.assign(defaults, this.forgotPasswordConfig || {});
    },
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  methods: {
    submit: function () {
      if (this.username.length === 0) return;
      if (this.username?.trim()?.toLowerCase() === 'demo@priorit.io') {
        this.setError('Demo account password cannot be reset');
        return;
      }

      this.loading = true;
      this.username = this.username.toLowerCase();
      this.$Amplify.Auth.forgotPassword(this.username)
        .then(() => {
          this.setError(false);
          this.sent = true;
          this.loading = false;
          this.logger.info('forgotPassword success');
        })
        .catch(e => {
          this.setError(e);
          if (e.code === 'UserNotFoundException') {
            this.sent = true;
          }
          this.loading = false;
        });
    },
    verify: function () {
      this.loading = true;
      this.username = this.username.toLowerCase();
      this.$Amplify.Auth.forgotPasswordSubmit(this.username, this.code, this.password)
        .then(() => {
          this.setError('');
          this.logger.info('forgotPasswordSubmit success');
          this.loading = false;
          AmplifyEventBus.$emit('authState', 'signIn');
        })
        .catch(e => {
          this.setError(e);
          this.loading = false;
        });
    },
    signIn: function () {
      AmplifyEventBus.$emit('authState', 'signIn');
    },
    setError: function (e) {
      if (!e || e.code === 'UserNotFoundException') {
        this.error = '';
        return;
      }
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    },
  },
};
</script>
